/**
 * @prettier
 * @flow
 */
export function getSignedOutReasonInLocalStorage(): string | void {
    const item = window.localStorage.getItem(KEY_NAME);
    return item ? JSON.parse(item) : undefined;
}

export const KEY_NAME = 'signedOutReason';
